var r=32,a=16,e=52;export{e as TABLE_HEADER_HEIGHT,r as TABLE_PAGINATION_HEIGHT,a as TABLE_PAGINATION_MARGIN_TOP};
